// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upload-result-backdrop {
  background-color: rgba(15, 23, 42, 0.45) !important;
}

.upload-result-paper {
  border-radius: 16px !important;
  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.18) !important;
  overflow: hidden !important;
  max-width: 520px !important;
}

.upload-result-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 18px 20px 14px;
  border-bottom: 1px solid #eef2f7;
  background: #fff;
}

.upload-result-header-main {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  min-width: 0;
}

.upload-result-icon {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
}

.upload-result-icon.ok {
  background: #ecfdf5;
  color: #047857;
}

.upload-result-icon.fail {
  background: #fef2f2;
  color: #b91c1c;
}

.upload-result-heading {
  margin: 0;
  font-size: 1.15rem;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.02em;
  line-height: 1.25;
}

.upload-result-subtitle {
  margin: 4px 0 0;
  font-size: 0.82rem;
  color: #64748b;
  line-height: 1.4;
}

.upload-result-close {
  color: #64748b !important;
  margin-top: -4px;
}

.upload-result-body {
  padding: 16px 20px 8px !important;
  background: #f8fafc;
}

.upload-result-stats {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  margin-bottom: 14px;
}

@media (max-width: 480px) {
  .upload-result-stats {
    grid-template-columns: 1fr;
  }
}

.upload-result-stat {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 12px 12px 10px;
  text-align: center;
}

.upload-result-stat-value {
  display: block;
  font-size: 1.35rem;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.03em;
  line-height: 1.1;
}

.upload-result-stat-value.ok {
  color: #047857;
}

.upload-result-stat-value.warn {
  color: #b45309;
}

.upload-result-stat-value.bad {
  color: #b91c1c;
}

.upload-result-stat-label {
  display: block;
  margin-top: 4px;
  font-size: 0.72rem;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.upload-result-note {
  margin: 0 0 12px;
  font-size: 0.8rem;
  color: #64748b;
  line-height: 1.45;
}

.upload-result-details {
  margin: 0;
  padding: 12px 14px;
  max-height: 240px;
  overflow: auto;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  font-size: 0.8rem;
  line-height: 1.5;
  color: #334155;
  white-space: pre-wrap;
  word-break: break-word;
  font-family: inherit;
}

.upload-result-details.is-error {
  border-color: #fecaca;
  background: #fffafa;
  color: #991b1b;
}

.upload-result-actions {
  padding: 12px 20px 16px !important;
  gap: 8px;
  border-top: 1px solid #eef2f7;
  background: #fff;
  flex-wrap: wrap;
}

.upload-result-btn-secondary {
  text-transform: none !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
  border-color: #cbd5e1 !important;
  color: #334155 !important;
}

.upload-result-btn-primary {
  text-transform: none !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
  background: #0ea5e9 !important;
  box-shadow: none !important;
}

.upload-result-btn-primary:hover {
  background: #0284c7 !important;
}

.upload-result-btn-muted {
  text-transform: none !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
  color: #64748b !important;
}
`, "",{"version":3,"sources":["webpack://./src/Css/UploadResultDialog.css"],"names":[],"mappings":"AAAA;EACE,mDAAmD;AACrD;;AAEA;EACE,8BAA8B;EAC9B,yDAAyD;EACzD,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,QAAQ;EACR,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,6BAA6B;EAC7B,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,6BAA6B;EAC7B,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,6BAA6B;EAC7B,yBAAyB;AAC3B","sourcesContent":[".upload-result-backdrop {\r\n  background-color: rgba(15, 23, 42, 0.45) !important;\r\n}\r\n\r\n.upload-result-paper {\r\n  border-radius: 16px !important;\r\n  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.18) !important;\r\n  overflow: hidden !important;\r\n  max-width: 520px !important;\r\n}\r\n\r\n.upload-result-header {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n  padding: 18px 20px 14px;\r\n  border-bottom: 1px solid #eef2f7;\r\n  background: #fff;\r\n}\r\n\r\n.upload-result-header-main {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 12px;\r\n  min-width: 0;\r\n}\r\n\r\n.upload-result-icon {\r\n  flex-shrink: 0;\r\n  width: 40px;\r\n  height: 40px;\r\n  border-radius: 10px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 1.25rem;\r\n}\r\n\r\n.upload-result-icon.ok {\r\n  background: #ecfdf5;\r\n  color: #047857;\r\n}\r\n\r\n.upload-result-icon.fail {\r\n  background: #fef2f2;\r\n  color: #b91c1c;\r\n}\r\n\r\n.upload-result-heading {\r\n  margin: 0;\r\n  font-size: 1.15rem;\r\n  font-weight: 700;\r\n  color: #0f172a;\r\n  letter-spacing: -0.02em;\r\n  line-height: 1.25;\r\n}\r\n\r\n.upload-result-subtitle {\r\n  margin: 4px 0 0;\r\n  font-size: 0.82rem;\r\n  color: #64748b;\r\n  line-height: 1.4;\r\n}\r\n\r\n.upload-result-close {\r\n  color: #64748b !important;\r\n  margin-top: -4px;\r\n}\r\n\r\n.upload-result-body {\r\n  padding: 16px 20px 8px !important;\r\n  background: #f8fafc;\r\n}\r\n\r\n.upload-result-stats {\r\n  display: grid;\r\n  grid-template-columns: repeat(3, minmax(0, 1fr));\r\n  gap: 10px;\r\n  margin-bottom: 14px;\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .upload-result-stats {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n\r\n.upload-result-stat {\r\n  background: #fff;\r\n  border: 1px solid #e2e8f0;\r\n  border-radius: 10px;\r\n  padding: 12px 12px 10px;\r\n  text-align: center;\r\n}\r\n\r\n.upload-result-stat-value {\r\n  display: block;\r\n  font-size: 1.35rem;\r\n  font-weight: 700;\r\n  color: #0f172a;\r\n  letter-spacing: -0.03em;\r\n  line-height: 1.1;\r\n}\r\n\r\n.upload-result-stat-value.ok {\r\n  color: #047857;\r\n}\r\n\r\n.upload-result-stat-value.warn {\r\n  color: #b45309;\r\n}\r\n\r\n.upload-result-stat-value.bad {\r\n  color: #b91c1c;\r\n}\r\n\r\n.upload-result-stat-label {\r\n  display: block;\r\n  margin-top: 4px;\r\n  font-size: 0.72rem;\r\n  font-weight: 600;\r\n  color: #64748b;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.04em;\r\n}\r\n\r\n.upload-result-note {\r\n  margin: 0 0 12px;\r\n  font-size: 0.8rem;\r\n  color: #64748b;\r\n  line-height: 1.45;\r\n}\r\n\r\n.upload-result-details {\r\n  margin: 0;\r\n  padding: 12px 14px;\r\n  max-height: 240px;\r\n  overflow: auto;\r\n  background: #fff;\r\n  border: 1px solid #e2e8f0;\r\n  border-radius: 10px;\r\n  font-size: 0.8rem;\r\n  line-height: 1.5;\r\n  color: #334155;\r\n  white-space: pre-wrap;\r\n  word-break: break-word;\r\n  font-family: inherit;\r\n}\r\n\r\n.upload-result-details.is-error {\r\n  border-color: #fecaca;\r\n  background: #fffafa;\r\n  color: #991b1b;\r\n}\r\n\r\n.upload-result-actions {\r\n  padding: 12px 20px 16px !important;\r\n  gap: 8px;\r\n  border-top: 1px solid #eef2f7;\r\n  background: #fff;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.upload-result-btn-secondary {\r\n  text-transform: none !important;\r\n  font-weight: 600 !important;\r\n  border-radius: 8px !important;\r\n  border-color: #cbd5e1 !important;\r\n  color: #334155 !important;\r\n}\r\n\r\n.upload-result-btn-primary {\r\n  text-transform: none !important;\r\n  font-weight: 600 !important;\r\n  border-radius: 8px !important;\r\n  background: #0ea5e9 !important;\r\n  box-shadow: none !important;\r\n}\r\n\r\n.upload-result-btn-primary:hover {\r\n  background: #0284c7 !important;\r\n}\r\n\r\n.upload-result-btn-muted {\r\n  text-transform: none !important;\r\n  font-weight: 600 !important;\r\n  border-radius: 8px !important;\r\n  color: #64748b !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
